export default __webpack_public_path__ + "static/media/done.cc5a59a7.gif";